import { useEffect, useState } from "react";
import { api } from "./api";

let catalog = null;
let request = null;

export const usePricingCatalog = () => {
  const [value, setValue] = useState(catalog);
  useEffect(() => {
    let active = true;
    if (!request) {
      request = api.get("/billing/plans").then(({ data }) => {
        catalog = data;
        return data;
      }).catch(() => {
        request = null;
        return null;
      });
    }
    request.then((data) => { if (active && data) setValue(data); });
    return () => { active = false; };
  }, []);
  return value;
};

export const formatInr = (value) =>
  Number(value).toLocaleString("en-IN", { maximumFractionDigits: 2 });
